// @mui
import PropTypes from 'prop-types';
import { alpha, styled } from '@mui/material/styles';
import { Card, Typography } from '@mui/material';
import { useNavigate } from 'react-router-dom';
// utils
import { fShortenNumber } from '../../utils/formatNumber';
// components
import Iconify from '../Iconify';

// ----------------------------------------------------------------------

const IconWrapperStyle = styled('div')(({ theme }) => ({
  margin: 'auto',
  display: 'flex',
  borderRadius: '50%',
  alignItems: 'center',
  width: theme.spacing(9),
  height: theme.spacing(9),
  justifyContent: 'center',
  marginBottom: theme.spacing(1),
}));

// ----------------------------------------------------------------------

TabCard.propTypes = {
  color: PropTypes.string,
  icon: PropTypes.string,
  title: PropTypes.string.isRequired,
  total: PropTypes.number.isRequired,
  sx: PropTypes.object,
};

export default function TabCard({
  title,
  name,
  icon,
  color = 'primary',
  sx,
  navigate,
  count,
  navigateOptions = {},
  ...other
}) {
  const navigateTo = useNavigate();
  return (
    <Card
      sx={{
        py: 5,
        boxShadow: 0,
        textAlign: 'center',
        color: (theme) => theme.palette[color].darker,
        bgcolor: (theme) => theme.palette[color].lighter,
        cursor: 'pointer',
        height: '100%',
        ...sx,
      }}
      {...other}
      onClick={() => navigateTo(navigate, navigateOptions)}
    >
      <IconWrapperStyle
        sx={{
          color: (theme) => theme.palette[color].dark,
          backgroundImage: (theme) =>
            `linear-gradient(135deg, ${alpha(theme.palette[color].dark, 0)} 0%, ${alpha(
              theme.palette[color].dark,
              0.24
            )} 100%)`,
        }}
      >
        {<Iconify icon={icon} width={24} height={24} />}
      </IconWrapperStyle>

      {!!count && (
        <Typography variant="h4" sx={{ color: (theme) => theme.palette[color].dark }}>
          {fShortenNumber(count)}
        </Typography>
      )}

      <Typography variant="subtitle2" sx={{ opacity: 0.72 }}>
        {title}
      </Typography>
      {!!name && (
        <Typography variant="subtitle2" sx={{ opacity: 0.72 }}>
          {name}
        </Typography>
      )}
    </Card>
  );
}
